var React = require('react');
var ReactNative = require('react-native');

var {
  Image,
  View,
} = ReactNative;

var ReUpImage = require("create-react-class")(
{
  getDefaultProps : function()
  {
    return {
      backgroundImage:null,
      style:{},
    }
  },

  getInitialState : function()
  {
    return {
      lastImage:null,
      currentImage:null,
    }
  },

  setImage : function(image)
  {
    if( image == null )
    {
      this.setState({lastImage:null, currentImage:null});
    }
    else
    {
      this.setState({lastImage:this.state.currentImage, currentImage:image});
    }
  },

  render: function()
  {
    var {style, ...other} = this.props;

    return (
      <View style={[style]}>
      {
        this.props.backgroundImage != null ?
          <Image key={this.props.backgroundImage + "bg"} source={{uri: this.props.backgroundImage}} resizeMode={"stretch"} style={{position:'absolute', top:0, left:0, right:0, bottom:0}} />
        : null
      }
      {
        this.state.lastImage != null ?
          <Image key={this.state.lastImage} source={{uri: this.state.lastImage}} resizeMode={"stretch"} style={{position:'absolute', top:0, left:0, right:0, bottom:0}} />
        : null
      }
      {
        this.state.currentImage != null ?
          <Image key={this.state.currentImage} source={{uri: this.state.currentImage}} resizeMode={"stretch"} style={{position:'absolute', top:0, left:0, right:0, bottom:0}} />
        : null
      }
      </View>
    )
  }
});

module.exports = ReUpImage;
